import React from 'react';

function RhPage() {
  return (
    <div style={{ padding: 24 }}>
      <h1>Ressources Humaines</h1>
      <p>Page `fhc-module-rh.html` convertie en composant React.</p>
    </div>
  );
}

export default RhPage;
